import { useLocation } from 'react-router'
import { DocsHomePage } from './DocsHomePage'
import { DocsPageView } from './DocsPageView'
import './docs.css'

function slugFromPathname(pathname: string) {
  return pathname.replace(/^\/docs\/?/, '').replace(/\/$/, '')
}

export function DocsSlugRouter() {
  const { pathname } = useLocation()
  const slug = slugFromPathname(pathname)

  if (!slug) {
    return <DocsHomePage />
  }

  return <DocsPageView slug={slug} />
}
